import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { CoachOption } from '../../api/useCoachRoster'

type Props = {
  autoFocus?: boolean
  disabled?: boolean
  label: string
  options: CoachOption[]
  value: string | null
  onChange: (coachId: string | null) => void
  helperText?: string
}

// Always resolves to a real coach id; typing filters the roster rather than accepting free text.
const ProviderPicker = ({
  label,
  options,
  value,
  onChange,
  disabled = false,
  autoFocus = false,
  helperText,
}: Props) => (
  <Autocomplete
    size="small"
    disabled={disabled}
    options={options}
    getOptionLabel={(option) => option.name}
    isOptionEqualToValue={(option, selected) => option.id === selected.id}
    value={options.find((option) => option.id === value) ?? null}
    onChange={(_event, selected) => onChange(selected?.id ?? null)}
    renderInput={(params) => (
      <TextField {...params} label={label} placeholder="Unassigned" autoFocus={autoFocus} helperText={helperText} />
    )}
    sx={{ minWidth: 220 }}
  />
)

export default ProviderPicker
